import { useRef, useState } from 'react';

const LOGO_SRC = '/images/logo/Logo.png';
const MAX_RETRIES = 3;

function BrandMark({ className = 'brand-logo', fallbackClassName = 'brand-mark' }) {
  const [logoFailed, setLogoFailed] = useState(false);
  const retryCount = useRef(0);

  if (logoFailed) {
    return <span className={fallbackClassName}>&#10022;</span>;
  }

  const handleError = (event) => {
    if (retryCount.current < MAX_RETRIES) {
      retryCount.current += 1;
      const img = event.currentTarget;
      window.setTimeout(() => {
        img.src = `${LOGO_SRC}?retry=${retryCount.current}`;
      }, 500 * retryCount.current);
      return;
    }
    setLogoFailed(true);
  };

  return (
    <img
      src={LOGO_SRC}
      alt="Sundaravel Group logo"
      className={className}
      onError={handleError}
    />
  );
}

export default BrandMark;
